module.exports = __webpack_public_path__ + "media/icons/half_star-356624e9.svg";